
import { Component, Vue, Prop } from "vue-property-decorator";
import {Getter} from "vuex-class";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiBell, mdiBellOffOutline } from "@mdi/js";

@Component({
  components: {
    SvgIcon,
  },
})
export default class KeySelected extends Vue {

  @Prop({ default: [] })
  public selectedKeys: any[];

  @Prop({ default: true })
  public displayCreateGroup: boolean;

  @Prop({ default: false })
  public displayFollowOptions: boolean;

  @Getter private currentUser: any;
  @Getter private canDoInEnvCompany: (right: string) => boolean;

  private mdiBell = mdiBell;
  private mdiBellOffOutline = mdiBellOffOutline;

  get canCreateGroup(): boolean {
    return this.selectedKeys.every((key) => this.canDoInEnvCompany("MANAGE_KEY_GROUPS"));
  }

  get canFollowKeys(): boolean {
    return this.selectedKeys.some((key) => !key.isFollowed);
  }

  get canUnfollowKeys(): boolean {
    return this.selectedKeys.some((key) => key.isFollowed);
  }

  get canArchive(): boolean {
    return this.selectedKeys.every((key) => this.canDoInEnvCompany("ARCHIVE_KEY"));
  }
}
